import { ApolloClient } from '@apollo/client';
import getBookingCartByUid from 'Common/functions/getBookingCartByUid';
import { AppCookie, getCookie, setCookie } from './Cookie';
import getOrInitializeBookingCart from 'Common/functions/getOrInitializeBookingCart';

export const getBookingCart = async (
  client: ApolloClient<object>,
  bookingCartUid: string | undefined,
) => {
  if (!bookingCartUid) {
    return;
  }

  const cart = await getBookingCartByUid(
    client.query,
    undefined,
    bookingCartUid,
  );

  if (cart) {
    return cart;
  }
};

export const getBookingCartUidMap = () => {
  const bookingCartUidMap = getCookie(AppCookie.CustomerBookingCartUidMap);
  if (bookingCartUidMap) {
    return JSON.parse(bookingCartUidMap);
  }

  return {};
};

export const getBookingCartUid = (map: Record<string, string>, serviceProviderId: string | null) => {
  if (serviceProviderId) {
    const bookingCartUid = map[serviceProviderId];
    if (bookingCartUid) {
      return bookingCartUid;
    }
  }
  return null;
};

export const getOrInitializeBookingCartUid = async (
  mutate: ApolloClient<object>['mutate'],
  bookingCartUid: string | undefined,
  serviceProviderUid: string,
  serviceOfferingUid: string | undefined,
) => {
  if (bookingCartUid) {
    return bookingCartUid;
  }

  const cart = await getOrInitializeBookingCart(
    mutate,
    undefined,
    serviceProviderUid,
    undefined,
    serviceOfferingUid,
  );
  if (!cart) {
    return null;
  }

  return cart.uid;
};

export const ensureBookingCartCookieClientSide = (
  key: string,
  currentCookieValue: string | undefined,
  nextCookieValue: string,
) => {
  if (nextCookieValue !== currentCookieValue) {
    const bookingCartMap = {
      [key]: nextCookieValue,
    };
    setCookie(
      AppCookie.CustomerBookingCartUidMap,
      JSON.stringify(bookingCartMap),
    );
  }
};

